// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"6a53b9b9","113":"d4c246a0","137":"eb74f81a","228":"1ba031e7","490":"b220a901","496":"58de577a","522":"56200d4d","625":"13a58140","710":"af2cd3e4","974":"b137f28a"}[chunkId] + ".chunk.js";
};